export const preloadImagesAndDetectAllLoaded = (imageUrls, callback) => {
  const images = [];
  let imagesLoadedCount = 0;
  const totalImages = imageUrls.length;

  if (totalImages) {
    // Preload specified images (but don't show them)
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.style.display = 'none'; // Keep the image hidden
      document.body.appendChild(img); // Add to DOM (hidden)
      images.push();
      // Track when each image is loaded or fails
      // eslint-disable-next-line
      img.onload = img.onerror = () => {
        imagesLoadedCount += 1;
        // eslint-disable-next-line
        if (imagesLoadedCount === totalImages) {
          callback(true, images); // All images preloaded
        }
      };
    });
  } else {
    callback(true, images);
  }
};
